// extracted by mini-css-extract-plugin
export default {"root":"EditedMarker-root-0b8fa4556fa9011921be1747687a80c7"};